import { useRef } from "react"

export const useVariable = <T>(initial: T): [T, (newVal: T) => void] => {
    const ref = useRef<T>(initial);
    return [ref.current, (newVal: T) => ref.current = newVal];
}